var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Text as FluentText, concatStyleSets, useTheme } from "@fluentui/react";
import React from "react";
import { getBaseTextStyle } from "./Text.styles";
// The Text component is a generic component which wraps the FluentUI Text component, providing some commonly used properties for styling that make the component
// easier to use. In the future, styling may also be applied if needed to adhere to Windows Visual Toolkit specificaitons, so please do not use the FluentUI Text
// component directly and opt to use this component instead.
//
// - The "variant" prop can be used to select the desired Type Ramp defined in appTheme.fonts in appTheme.tsx
export const Text = (_a) => {
    var { children, color, marginBottom, textAlign, styles } = _a, rest = __rest(_a, ["children", "color", "marginBottom", "textAlign", "styles"]);
    const theme = useTheme();
    return (React.createElement(FluentText, Object.assign({}, rest, { styles: concatStyleSets(getBaseTextStyle(theme, color, marginBottom, textAlign), styles) }), children));
};
